import { environment } from 'src/environments/environment'
import { EscaltionComponent } from './escaltion.component'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AuthGuardService } from '../auth/auth-guard.service'
import { ProcessComponent } from '../process/process.component'
import { ProcessRecordsComponent } from '../process/process-records/process-records.component'
import { ProcessAnalyticsComponent } from '../process/process-analytics/process-analytics.component'
import { ProcessOverviewComponent } from '../process/process-overview/process-overview.component'
import { ProcessManageComponent } from '../process/process-manage/process-manage.component'
import { RecordViewComponent } from '../process/process-records/record-view/record-view.component'

export const appRoutes = [
  {
    path: `department/${environment.config.escalation.id}`,
    component: EscaltionComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: `department/${environment.config.escalation.id}/process/:processId`,
    component: ProcessComponent
  },
  {
    path: `department/${environment.config.escalation.id}/process/:processId/records`,
    component: ProcessRecordsComponent
  },
  {
    path: `department/${environment.config.escalation.id}/process/:processId/records/:recordId`,
    component: RecordViewComponent
  },
  {
    path: `department/${environment.config.escalation.id}/process/:processId/analytics`,
    component: ProcessAnalyticsComponent
  },
  {
    path: `department/${environment.config.escalation.id}/process/:processId/overview`,
    component: ProcessOverviewComponent
  },
  {
    path: `department/${environment.config.escalation.id}/process/:processId/manage`,
    component: ProcessManageComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(appRoutes)],

  exports: [RouterModule]
})
export class EscalationRoutingModule {}
